import React, { Component } from "react";
import Avatar from "@mui/material/Avatar";
import moment from "moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Menu, MenuItem } from "@mui/material";
import EnlargeImage from "../../customFunctions/EnlargeImage";
import getBaseUrl from "../../customFunctions/getBaseUrl";
import { API_URL } from "../../config/app-config";

class ServiceRecordGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opendeleteproductDialogue: false,
      anchorEl: null,
      selectedEditData: {},
    };
  }

  render() {
    console.log("this.props", this.props);
    return (
      <>
        <div className="adjust-grid-container-2">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  <th>Records</th>
                  <th>Performed By</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.props.serviceResourceRecord.map((e) => (
                  <tr>
                    <td class="avatar-cell">
                      <div class="avatar">
                        <Avatar
                          alt={`${e.machineName}`}
                          src={
                            e.Image !== null
                              ? `${API_URL}auth/assets/${e.Image}`
                              : null
                          }
                          sx={{
                            objectFit: "cover",
                            transition: "transform 0.3s ease-in-out", // Add a smooth transition effect
                            "&:hover": {
                              transform: "scale(1.8)",
                              zIndex: 2, // Example: Enlarge the image size on hover
                            },
                          }}
                          onClick={() => this.handleAvatarClick(e)}
                        >
                          {e.Image === null && (
                            <span>{e.machineName.charAt(0).toUpperCase()}</span>
                          )}
                        </Avatar>
                        <div class="name">
                          {e.machineName.charAt(0).toUpperCase() +
                            e.machineName.slice(1)}
                        </div>
                      </div>
                    </td>
                    <td>
                      {e.isDealer
                          ? "Dealer"
                          : this.capitalizeFirstLetter(e.personTask)}
                    </td>

                    <td>
                    {moment.utc(e.updatedDate).format('dddd, D MMMM YYYY')}
                    </td>

                    <td>
                      {
                        <>
                          <MoreHorizIcon
                            onClick={(event) =>
                              this.handleFilterClick(event, e)
                            }
                          />{" "}
                          <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleFilterClose2}
                            className="exclude-menu"
                          >
                            <MenuItem
                              onClick={() => this.handleFilterClose("edit", e)}
                            >
                              <VisibilityIcon />{" "}
                              <span className="inisde-the-action">View</span>
                            </MenuItem>
                          </Menu>
                        </>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
              {this.props.serviceResourceRecord.length === 0 && (
                <>
                  {" "}
                  <div
                    style={{
                      fontSize: "larger",
                      fontWeight: "bolder",
                    }}
                  >
                    {"No Data Found"}
                  </div>{" "}
                </>
              )}
            </table>
          </div>
        </div>
        {this.state.isModalOpen && (
          <EnlargeImage
            onClose={this.handleModalClose}
            imageUrl={
              this.state.Image !== null
                ? `${API_URL}auth/assets/${this.state.Image}`
                : null
            }
          />
        )}
      </>
    );
  }

  capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  handleAvatarClick = (e) => {
    if (e.Image !== null) {
      this.setState({
        isModalOpen: true,
        Image: e.Image,
      });
    }
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleFilterClick = (event, data) => {
    console.log("event in fileter click", event, data);
    this.setState({
      anchorEl: event.target,
      selectedEditData: data,
    });
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleFilterClose = (getState, e) => {
    console.log("e in handle filter close", e);

    if (getState === "edit") {
      this.props.togettheServiceData(this.state.selectedEditData);
      this.handleFilterClose2();
    }
  };
}
export default ServiceRecordGrid;
